export const PREFERRED_LOCALE_COOKIE_KEY = "preferred-locale-code";
export const PREFERRED_SEGMENT_KEY_COOKIE_KEY = "preferred-segment-key";
export const PREFERRED_SEGMENT_SELECTOR_COOKIE_KEY = "preferred-segment-overlay";
export const LOCALE_MISMATCH_COOKIE = "locale-mismatch";
